import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APITheoNgayHieuLuc = {
  LIST_THEO_NGAY_HIEU_LUC: `${BASE_API_URL_CAP_DIEN}/theo-ngay-hieu-luc/list`,
  CREATE_THEO_NGAY_HIEU_LUC: `${BASE_API_URL_CAP_DIEN}/theo-ngay-hieu-luc/create`,
  UPDATE_THEO_NGAY_HIEU_LUC: `${BASE_API_URL_CAP_DIEN}/theo-ngay-hieu-luc/update`,
  REMOVE_THEO_NGAY_HIEU_LUC: `${BASE_API_URL_CAP_DIEN}/theo-ngay-hieu-luc/delete`,
};
